export default function ProjectBibleActions(props) {
    return(
        <div>
            ProjectBibleActions
        </div>
    )
}